// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import mixin from "./mixin"
import util from './utils/index'
import YueUI from 'yuejuan-ui'

Vue.use(YueUI)

import './assets/styles/index.scss'

Vue.config.productionTip = false

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let option = {
  getDoubleTapZoom: function (isMouseClick, item) {
    return 1
  }
}
Vue.use(preview, option)

import ElementUI from 'element-ui'
Vue.use(ElementUI)
Vue.mixin(mixin)

import NoData from './components/nodata/index'
Vue.use(NoData)

import VCard from "./components/card/index";
Vue.use(VCard);

Vue.directive('authvalidate', {
  update: function (el, binding) {
    if (!util.isAuth(binding.value)) {
      el.style.display = 'none'
    }
  }
})


Vue.prototype.$menuAuth = util.isAuth

// 注册全局过滤函数
import * as filters from './filter/index'
Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js